(function($, root) {
  "use strict";

  // $.initTimerAnimationDurations = function() {
  //   // let fullwidth = $(document).width();
  //
  //   $('timer fill').css({
  //     '-webkit-animation-duration': ((window.rdo.transitions.content - window.rdo.transitions.transition) / 1000) + 's'
  //   });
  //   $('#full-page-background .overlay').css({
  //     '-webkit-animation-duration': ((window.rdo.transitions.content - window.rdo.transitions.transition) / 1000) + 's'
  //   });
  // }

  // $.resetContentAnimations = function() {
  //   // console.log('css animations reset');
  //   // $('timer fill').removeClass('progress-timer');
  //   $('#full-page-background .overlay').removeClass('progress-timer');
  //
  // }

  $.showSpinner = function() {

    $('#spinner').removeClass('d-none').addClass('fadeIn');
    $.hideContent();
  }

  $.hideSpinner = function() {

    $('#spinner').addClass('d-none').removeClass('fadeIn');
    $.showContent();
  }

  $.hideContent = function() {
    $('#content-player').removeClass('fadeIn').addClass('fadeOut');
  }

  $.showContent = function() {
    $('#content-player').removeClass('fadeOut').addClass('fadeIn');
  }

  $.showContentDetails = function() {
    $('#content-detail').removeClass('fadeOut').addClass('fadeIn').css('display', 'flex');

  }
  $.hideContentDetails = function() {
    $('#content-detail').hide();

  }

  $.hideTimelines = function() {
    $('#vertical-timeline .wrapper , #horizontal-timeline ul').removeClass('fadeIn').addClass('fadeOut');

  }
  $.showTimelines = function() {
    $('#vertical-timeline .wrapper , #horizontal-timeline ul').removeClass('fadeOut').addClass('fadeIn');

  }

  $.showGallery = function() {
    $('gallery').show();
  }

  $.hideGallery = function() {
    $('gallery').hide();
  }

  $.resetTimerAnimations = function() {
    // console.log('css animations reset');
    $('timer fill').removeClass('progress-timer');
    // $('#full-page-background .overlay').removeClass('progress-timer');

  }

  $.setTimerAnimations = function(duration) {
    duration = duration || window.rdo.transitions.content;

    $('timer fill').css({
      '-webkit-animation-duration': ((duration) / 1000) + 's',
      'animation-duration': ((duration) / 1000) + 's',
      '-ms-animation-duration': ((duration) / 1000) + 's'
    });
    $('#full-page-background .overlay').css({
      '-webkit-animation-duration': ((duration) / 1000) + 's',
      'animation-duration': ((duration) / 1000) + 's',
      '-ms-animation-duration': ((duration) / 1000) + 's'
    });

  };



  $.showSkipButton = function() {
    $('intro .buttons button.skip').removeClass('fadeOut').addClass('fadeIn');
  };

  $.hideSkipButton = function() {
    $('intro .buttons button.skip').removeClass('fadeIn').addClass('fadeOut');
  };

  $.startTimerAnimations = function() {
    // duration = duration || window.rdo.transitions.content;
    $.setTimerAnimations();
    // $.initTimerAnimationDurations();

    //init timer animation durations:

    //delay the animations a little:
    setTimeout(function() {
      $('timer fill').addClass('progress-timer');
      $('#full-page-background .overlay').addClass('progress-timer');
    }, 1);
    // console.log('css animations started');

  }

})(jQuery, this);
